import { render, staticRenderFns } from "./REMPosition.vue?vue&type=template&id=388d8e49&scoped=true&"
import script from "./REMPosition.vue?vue&type=script&lang=js&"
export * from "./REMPosition.vue?vue&type=script&lang=js&"
import style0 from "./REMPosition.vue?vue&type=style&index=0&id=388d8e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d8e49",
  null
  
)

export default component.exports